import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import SchemaMarkup from './components/feature/SchemaMarkup';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SchemaMarkup />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
